











import Vue from "vue";
import ParamountNav from "@/components/ParamountNav.vue";

export default Vue.extend({
  components: {
    ParamountNav
  }
});
